import { render } from "./BildirimSatiri.vue?vue&type=template&id=6ab9d63e"
import script from "./BildirimSatiri.vue?vue&type=script&lang=js"
export * from "./BildirimSatiri.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__